// extracted by mini-css-extract-plugin
module.exports = {"authorizeRejectButtons":"styles_authorizeRejectButtons__30JJp"};